import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { PageMetaService } from '@spartacus/core';
import { SeoMetaService, PageMetaLinkService } from '@spartacus/storefront';

@Injectable({
  providedIn: 'root',
})
export class CustomSeoMetaService extends SeoMetaService {
  constructor(
    ngTitle: Title,
    ngMeta: Meta,
    pageMetaService: PageMetaService,
    pageMetaLinkService: PageMetaLinkService
  ) {
    super(ngTitle, ngMeta, pageMetaService, pageMetaLinkService);
  }

  override set description(value: string | undefined) {
    const fallbackValue = value || 'Andes Motor B2B - Compra de repuestos y gestión de flotas para Foton, Maxus, Iveco, Sany, Karry, Kaiyi, Agrale y Jetour.';
    this.addTag({ name: 'description', content: fallbackValue });
  }
}
